import React from "react";
import "./download.scss";
import { Button, Col, Row } from "antd";
import DownLoadLogo from "../../images/download-logo.png";
import Logo from "../../images/logo.png";
import Android from "../../images/android.png";
import { useTranslation } from "react-i18next";

async function handleDownload(){
  fetch('https://bee-loan.sgp1.digitaloceanspaces.com/version.json')
      .then(response => response.json())
      .then(data => {window.open(data[0].url, '_blank').focus();});
}

function Download() {
  const { t } = useTranslation();

  return (
    <div className="download-container">
      <div className="download-title-container">
        <Row justify="center">
          <Col>
            <p className="title">{t("Download")}</p>
          </Col>
        </Row>
      </div>

      <div className="download-desc-container">
        <Row justify="center">
          <Col>
            <img style={{border: "1px solid #ddd", borderRadius: "10%", background:"black"}} src={DownLoadLogo} alt="DownLoadLogo" />
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <div className="logo-name">Beeloan</div>
          </Col>
        </Row>

        <Row justify="center">
          <Col>
            <div className="logo-desc">{t("versionGetStarted")}</div>
          </Col>
        </Row>

        <Row justify="center">
          <Col sm={6} xs={12}>
            <div className="button-download-android">
              <Button onClick={handleDownload} >
                <img src={Android} alt="android" />
                {t("Download")}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Download;
